import React, { useState } from 'react'
import Page from 'layouts/Page'
import PageWrapper from '../../../PageWrapper'
import { PerformanceTable } from '../components/PerformanceTable'
import { Summary } from '../components/Summary'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { Select } from '@surecompanies/core_components'
import { Stack, Typography } from '@sureco/design-system'
import { ApplicationQueueUsRestrictedGate } from '../components/ApplicationQueueUsRestrictedGate'

const DATE_OPTIONS = [
  { label: '2026-01-01', value: '2026-01-01' },
  { label: '2025-01-01', value: '2025-01-01' },
]

export const ApplicationQueuePerformanceDashboard = () => {
  const [selectedBenefitEffectiveDate, setSelectedBenefitEffectiveDate] =
    useState<string>(DATE_OPTIONS[0].value)

  return (
    <PageWrapper>
      <Page
        title="Performance Dashboard"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Application Queues', path: '/application-queue' },
              {
                title: 'Performance Dashboard',
                path: '/application-queue/performance-dashboard',
              },
            ]}
          />
        }
        action={
          <Stack direction="row" align="center" space={8}>
            <Typography size={14} style={{ whiteSpace: 'nowrap' }}>
              Benefit Effective Date:
            </Typography>
            <Select
              placeholder="Select Date"
              value={selectedBenefitEffectiveDate}
              onChange={(value) =>
                setSelectedBenefitEffectiveDate(value as string)
              }
              options={DATE_OPTIONS}
              style={{ minWidth: '120px' }}
            />
          </Stack>
        }
      >
        <ApplicationQueueUsRestrictedGate>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
          >
            <PerformanceTable
              selectedBenefitEffectiveDate={selectedBenefitEffectiveDate}
            />
            <Summary
              selectedBenefitEffectiveDate={selectedBenefitEffectiveDate}
            />
          </div>
        </ApplicationQueueUsRestrictedGate>
      </Page>
    </PageWrapper>
  )
}
